import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/proage-logo.png'


const _hoisted_1 = { class: "uq-header-logo" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo ProAge",
  class: "header-logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "navbar-content d-flex align-items-center"
}
const _hoisted_4 = {
  id: "navbarToggleExternalContent",
  class: "uq-header-navbar collapse navbar-collapse"
}
const _hoisted_5 = { class: "navbar-nav navbar-nav-list ff-secondary" }
const _hoisted_6 = { class: "menu-item nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-home fw-semi me-8" }, null, -1)
const _hoisted_8 = { class: "menu-item nav-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-calendar fw-semi me-8" }, null, -1)
const _hoisted_10 = { class: "menu-item nav-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-circle fw-bold text-md" }, null, -1)
const _hoisted_12 = { class: "py-8 px-16" }
const _hoisted_13 = { class: "fw-medium text-sm" }
const _hoisted_14 = { class: "text-xs" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_16 = { class: "py-0 px-16 pb-8" }
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "hamburger-box" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "aria-hidden": "true",
    class: "hamburger-inner"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_logout = _resolveComponent("the-logout")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: {name: 'patient.home'},
        class: "navbar-brand logo"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (_ctx.authUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: {name: 'patient.home'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Inicio')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: {name: 'patient.calendar.show'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Agenda')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_dropdown, {
                  id: "user-header-dropdown",
                  "disable-icon": true,
                  "button-classes": "text-sm fw-medium bg-transparent shadow-none px-0",
                  class: "d-none d-lg-block",
                  "dropdown-classes": "dropdown-user dropdown-menu-end py-0"
                }, {
                  button: _withCtx(() => [
                    _hoisted_11
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.authUser.name), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.authUser.email), 1)
                    ]),
                    _hoisted_15,
                    _createElementVNode("li", _hoisted_16, [
                      _createVNode(_component_the_logout)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_the_logout, { class: "d-lg-none" })
              ])
            ])
          ]),
          _createElementVNode("button", {
            id: "navbar-custom-toggler",
            "aria-label": this.$t('Toggle navigation'),
            "aria-controls": "navbarToggleExternalContent",
            "aria-expanded": "false",
            class: "navbar-toggler hamburger hamburger--slider ms-4 ms-sm-12",
            "data-bs-target": "#navbarToggleExternalContent",
            "data-bs-toggle": "collapse",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_19, 8, _hoisted_17)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}